import { html } from "lit-element";
import { InspxObjectBase } from './inspx-object-base.js';
import { SharedStyles } from '../styles/shared-styles.js';
import { CardStyles } from '../styles/card-styles.js';
import { keyboardArrowDown, keyboardArrowUp, deleteForever } from '../styles/icons.js';


class InspxArrayGroup extends InspxObjectBase {
	shouldUpdate() {
		return this.data && this.parts;
	}

	render() {
		const collapseButton = this.collapsed ? keyboardArrowDown : keyboardArrowUp;

		return html`
			${SharedStyles}
            ${CardStyles}
            <style>
                .separator {
                    color: var(--primary-color);
                    fill: var(--primary-color);
                    margin-bottom: 10px;
                    border-bottom: 1px solid var(--primary-color);
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;   
                }

                .title{
                    display: flex;
                }

                .button {
                    fill: var(--primary-color);
                }
            </style>

			<div class="separator" ?collapsed="${this.collapsed}" @click="${this.collapserClickHandler}">
				<div class="title"><div @click="${(e)=>{ this.delClicked(e)}}">${deleteForever}</div>  ${this.cardtitle}</div>
                <div class="button">${collapseButton}</div>
			</div>
			<div class="c" ?hidden="${this.collapsed}">
				${this.parts.map(p => this.renderField(p))}
			</div>
		`;
	}
    
	delClicked(e){
		e.preventDefault();
		e.stopPropagation();
		this.dispatchEvent(new CustomEvent ("delete-item"));
	}

	collapserClickHandler() {
		this.collapsed = !this.collapsed;
		this.requestUpdate();
	}

	constructor() {
		super();
		this.collapsed = false;
	}
}

window.customElements.define('inspx-array-group', InspxArrayGroup);
